import React, { useState, useEffect } from "react";
import logo from '../../images/logo.png'
import { Button, Layout, Form, Input, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { Content } from "antd/lib/layout/layout";
import { LoginUser } from "../../App";

const { Header } = Layout;

interface SignUpProps {
    requestUrl: string
}

const LogIn: React.FC<SignUpProps> = ({ requestUrl }) => {
    const [loginUser, setLoginUser] = useState<LoginUser | undefined>(undefined)
    const navigate = useNavigate()

    const onFinish = (values: {email: string, password: string}) => {
        setLoginUser({
            'username': values.email,
            'password': values.password
        })
    };

    useEffect(() => {
        if(loginUser) {
            const requestOptions = {
                method: 'POST',
                headers : {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(loginUser)
            }

            const loginResponse = fetch(`${requestUrl}/auth/token/`, requestOptions)
                .then(response => {
                    if(response.status === 200) {
                        return response.json()
                    } else {
                        message.warning('Email and/or password is wrong.')
                    }
                })

            const setCookie = async () => {
                const tokens = await loginResponse;
                if(tokens) {
                    window.localStorage.setItem('access', tokens.access)
                    window.localStorage.setItem('refresh', tokens.refresh)
                    navigate('/portal')
                }
            }

            setCookie()
        }
    }, [loginUser, requestUrl, navigate])

    /////// Any? //////
    const onFinishFailed = (errorInfo: any) => {

    };

    return(
        <Layout className="site-layout-background">
            <Header className="header navbar-layout-background" >
                <div className='navbar-content'>
                    <div className='logo-area'>
                        <Link to='/' style={{ textDecoration: 'none' }}>
                            <img className='logo' alt='logo' src={logo} />
                        </Link>
                        <Link to='/' style={{ textDecoration: 'none' }}>
                            <h1>FairVote</h1>
                        </Link>
                    </div>
                    <div className='button-area'>
                        <p className='sign-up-switch'>Need an Account?</p>
                        <Link to='/signup' style={{ textDecoration: 'none' }}>
                            <Button type="primary">
                                Sign Up
                            </Button>
                        </Link>  
                    </div>
                </div>
            </Header>
            <Content className='page_content_card'>
                <div className='page_content'>
                    <div className='left_col'>
                        <div className='greet'>
                            <p className='welcome'>Welcome Again</p>
                            <p className='sign_up'>Sign In to get started!</p> 
                        </div>
                    </div>
                    <div className='right_col'>
                        <div className='right_col_inner'>
                            <Form
                                name="basic"
                                wrapperCol={{
                                    span: 24,
                                }}
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={onFinish}
                                onFinishFailed={onFinishFailed}
                                autoComplete="off" >
                                
                                <Form.Item
                                    name="email"
                                >
                                    <Input placeholder="E-mail" />
                                </Form.Item>

                                <Form.Item
                                    name="password"
                                >
                                    <Input.Password placeholder="Password"/>
                                </Form.Item>

                                <Form.Item
                                    wrapperCol={{
                                    offset: 0,
                                    span: 24,
                                    }}>
                                    <Button block type="primary" htmlType="submit">
                                        Log In
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>   
                </div>                             
            </Content>
        </Layout>
    )
};

export default LogIn;